import qc from 'qc'
import { getBinUuidFromFiles } from '@ps/bridge/qc/bin'
import { removeFileExtension } from '@com/utils/file'
import qcGame from '@ps/bridge/qc/qc-game'
import assets from '@ps/bridge/qc/assets'
import gameIframe from '@ps/bridge/iframe/iframe'
import { resetNodeDefaultLayout } from '@ps/bridge/qc/node/utils'
import { saveGlobalUrlMap } from '@ps/bridge/resource/global-url-map'
import iframe from '@ps/bridge/iframe/iframe'

export async function addImageNode({
  isPool,
  files,
  name,
  scene,
  padding,
  nodeName,
  pid,
  resourcePath,
  binUUID,
}: {
  isPool?: boolean
  files: {
    name: string
    data: string
  }[]
  name: string
  scene: qc.Node
  nodeName: string
  pid: number
  padding: string
  resourcePath: string
  binUUID?: string
}) {
  const prefixName = removeFileExtension(files[0].name)
  const pathPrefix = resourcePath

  const newNode = qcGame.add.image(scene)
  resetNodeDefaultLayout(newNode)

  // 是否含有九宫格配置
  if (padding && JSON.parse(padding).nine) {
    newNode.imageType = 1
  }
  // 优先使用 nodeName（nodeName 一般是文件本身的名字，保证用户添加资源后，资源对应节点的名字与文件名字一样，易于使用者查找）
  newNode.name = nodeName || name

  const assetsConfig = {
    uuid: isPool
      ? binUUID
      : getBinUuidFromFiles({
          files,
          binFileName: name + '.bin',
        }),
    url: `${pathPrefix}${prefixName}.bin`,
    override: true,
  }

  const asset = await assets.load(assetsConfig)
  const Texture = gameIframe.qc.Texture
  newNode.texture = new Texture(asset, 0)

  // 保存资源列表
  await saveGlobalUrlMap({
    projectKey: pid,
    uuid2url: assets.uuid2UrlConf,
  })
  return newNode
}
